import React from 'react';

export default function NoOptionsMessageComponent() {
  return (
    <p className="my-2 text-custom-gray-300 text-[15px] text-center">
      No results found
    </p>
  );
}
